import React from 'react';

const setupSteps = [
  {
    title: 'Login to your account',
    description: 'Use your registered email and password to securely enter the app.',
  },
  {
    title: 'Connect Telegram from Settings',
    description: 'If Telegram scanning is inactive, open Settings,enter phone number, send a code, and authorize your session.',
  },
  {
    title: 'Go to Discover and launch a scan',
    description: 'Enter search phrases, select a state, and start the scan.',
  },
  {
    title: 'Review and mark findings',
    description: 'Check the returned groups, review their signals, and mark them where necessary.',
  },
  {
    title: 'Monitor reports and reviewed records',
    description: 'Use the dashboard, live reports, and reviewed database to track ongoing activity.',
  },
];

const featureCards = [
  {
    title: 'Dashboard',
    description: 'Shows overall scan activity, summaries, and recent operational insights.',
  },
  {
    title: 'Discover',
    description: 'Main scanning workspace for Telegram discovery, filtering, and result analysis.',
  },
  {
    title: 'Live Reports',
    description: 'Displays synced or incoming report items that need monitoring or review.',
  },
  {
    title: 'Reviewed DB',
    description: 'Contains the reviewed group database with filters and exports.',
  },
  {
    title: 'Settings',
    description: 'Lets you update your profile, manage Telegram session access, and open helper tools.',
  },
  {
    title: 'State Info Editor',
    description: 'Optional page used to manage location datasets for state-based scan relevance.',
  },
];

export default function Guide() {
  return (
    <div className="page-shell guide-page">
      <header className="top-bar">
        <div>
          <h1 className="page-title">User Guide</h1>
          <p className="page-subtitle">Quick setup help and a simple explanation of what each page in the app does.</p>
        </div>
      </header>

      <section className="card guide-card">
        <div className="section-head">
          <div>
            <div className="eyebrow" style={{ color: '#166534' }}>SETUP</div>
            <h3 className="section-title">How to start scanning</h3>
          </div>
        </div>

        <div className="guide-steps">
          {setupSteps.map((step, index) => (
            <article key={step.title} className="guide-step">
              <div className="guide-step-index">{index + 1}</div>
              <div className="guide-step-body">
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="card guide-card">
        <div className="section-head">
          <div>
            <div className="eyebrow" style={{ color: '#1d4ed8' }}>FEATURES</div>
            <h3 className="section-title">What each page does</h3>
          </div>
        </div>

        <div className="guide-feature-grid">
          {featureCards.map((card) => (
            <article key={card.path} className="guide-feature">
              <h4>{card.title}</h4>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
